import React from "react";
import Loader from "../Loader";

export default function AppShell({
  header,
  footer,
  children,
  className = "",
  isLoading = false,
}) {
  return (
    <div
      className={["app-shell", "flex", "flex-col", className]
        .filter(Boolean)
        .join(" ")}
    >
      {header && <header className="rm-shell-header">{header}</header>}
      <main className="rm-shell-main flex-1">
        {isLoading ? <Loader /> : children}
      </main>
      {footer}
    </div>
  );
}
